import React, { createContext, useRef } from "react";
import { useHistory, useLocation } from "react-router-dom";

export const StorefrontNavigationContext = createContext(null);

// Track actual in-app destinations, not the browser's total history length.
// REPLACE (including variant changes) retains the preceding entry.
export function updateNavigationTrail(trail, location, action) {
  const entry = { key: location.key, pathname: location.pathname };
  if (!trail.entries.length) return { entries: [entry], index: 0 };
  if (trail.entries[trail.index].key === entry.key) {
    const entries = [...trail.entries];
    entries[trail.index] = entry;
    return { entries, index: trail.index };
  }
  if (action === "PUSH") return { entries: [...trail.entries.slice(0, trail.index + 1), entry], index: trail.index + 1 };
  if (action === "REPLACE") {
    const entries = [...trail.entries];
    entries[trail.index] = entry;
    return { entries, index: trail.index };
  }
  const index = trail.entries.findIndex(item => item.key === entry.key);
  return index >= 0 ? { entries: trail.entries, index } : { entries: [entry], index: 0 };
}

export default function StorefrontNavigation({ children }) {
  const location = useLocation();
  const history = useHistory();
  const trail = useRef({ entries: [], index: 0 });
  trail.current = updateNavigationTrail(trail.current, location, history.action);
  const previousPath = trail.current.entries[trail.current.index - 1]?.pathname || null;
  return <StorefrontNavigationContext.Provider value={previousPath}>{children}</StorefrontNavigationContext.Provider>;
}
